import ReactModal from 'react-modal'
import { FormState } from 'typings'
import TransmitModule from './TransmitModule'

export interface OTPModalProps {
  OTPCallback: (status?: boolean, jwt?: string) => void
  formValues: FormState
  open: boolean
}

const OTPModal = ({
  OTPCallback,
  formValues,
  open
}: OTPModalProps): JSX.Element => (
  <ReactModal
    isOpen={open}
    data-testid="otp-popup-modal"
    ariaHideApp={false}
    shouldCloseOnOverlayClick={false}
    contentLabel="OTP popup modal"
  >
    <TransmitModule
      popupCallback={(status?: boolean, jwt?: string) => {
        OTPCallback(status, jwt)
      }}
      formValues={formValues}
    />
    <section id="transmitContainer" />
  </ReactModal>
)

export default OTPModal
